module.exports = __webpack_public_path__ + "img/9788975278105.03980719.jpg";